import { Record } from 'immutable';

export const mkUndo = Record({
  key: undefined,
  actions: undefined,
  userMessage: undefined,
  disableUndoAction: undefined,
});
